import { Close as CloseIcon } from '@mui/icons-material';
import { Button, IconButton, Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';

interface ToolbarIconButtonProps {
  icon: React.ReactNode;
  tooltip: string;
  onClick: () => void;
  active?: boolean;
  sx?: any;
}

export const ToolbarIconButton: React.FC<ToolbarIconButtonProps> = ({
  icon,
  tooltip,
  onClick,
  active,
  sx,
}) => {
  return (
    <Tooltip title={tooltip}>
      <IconButton
        onClick={onClick}
        sx={{
          borderRadius: 1,
          padding: '8px',
          backgroundColor: active ? 'primary.main' : 'transparent',
          color: active ? 'white' : 'inherit',
          '& .MuiSvgIcon-root': {
            fontSize: '1.25rem',
          },
          transition: 'all 0.2s ease-in-out',
          ...sx,
        }}
      >
        {icon}
      </IconButton>
    </Tooltip>
  );
};

interface ActionButtonProps {
  label: string;
  onClick: () => void;
  sx?: any;
  disabled?: boolean;
}

export const ActionButton: React.FC<ActionButtonProps> = ({
  label,
  onClick,
  sx,
  disabled = false,
}) => {
  const StyledButton = styled(Button)(({ theme }) => ({
    height: '32px',
    minWidth: '80px',
    padding: theme.spacing(0.5, 2),
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: theme.shape.borderRadius,
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.common.white,
    fontSize: '0.875rem',
    textTransform: 'none',
    fontWeight: 500,
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
      borderColor: theme.palette.primary.main,
      boxShadow: 'none',
    },
    '&:active, &.Mui-focusVisible': {
      backgroundColor: theme.palette.primary.dark,
      borderColor: theme.palette.primary.dark,
      color: theme.palette.common.white,
    },
    ...sx,
  }));

  return (
    <StyledButton onClick={onClick} disabled={disabled} variant="outlined">
      {label}
    </StyledButton>
  );
};

export const CloseButton: React.FC<{ onClick: () => void }> = ({ onClick }) => {
  return (
    <IconButton
      onClick={onClick}
      size="small"
      sx={{
        padding: '8px',
        borderRadius: 1,
        backgroundColor: 'transparent',
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
          backgroundColor: 'primary.light',
        },
        '& .MuiSvgIcon-root': {
          fontSize: '1.25rem',
        },
      }}
    >
      <CloseIcon />
    </IconButton>
  );
};
